import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Card from "../../../components/Card/Card";
import { hasPermission } from "../../LessonPlanner/utils/lessonPlanUtils";
import { DIARY_PERMISSIONS } from "../WeeklyDiaryConstant";
import NoDiaryAccess from "./NoDiaryAccess";

/**
 * Renders the page only for users with DIARY_PERMISSIONS.VIEW (principal / reviewers);
 * everyone else gets a no-access message and no diary API is called.
 */
const withDiaryAccess = (Page) => {
  const GuardedPage = (props) => {
    const navigate = useNavigate();
    const canView = useMemo(() => hasPermission(DIARY_PERMISSIONS.VIEW), []);

    if (!canView) {
      return (
        <Card componentName="Weekly Diary" back={() => navigate(-1)}>
          <NoDiaryAccess />
        </Card>
      );
    }
    return <Page {...props} />;
  };
  GuardedPage.displayName = `withDiaryAccess(${Page.displayName || Page.name || "Page"})`;
  return GuardedPage;
};

export default withDiaryAccess;
